import {
  ADD_MANAFITH_FAILED,
  ADD_MANAFITH_LOADING,
  ADD_MANAFITH_REMOVE,
  ADD_MANAFITH_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
  Manafith: null,
  request: null,
};

export const manafithReducer = (
  state = initialState,
  action: {
    type: any;
    loading: any;
    payload: any;
    status: any;
    error: any;
    request: any;
  }
) => {
  switch (action.type) {
    case ADD_MANAFITH_LOADING:
      return {
        ...state,
        loading: true,
      };
    case ADD_MANAFITH_SUCCESS:
      return {
        ...state,
        loading: false,
        Manafith: action.payload,
        status: action.status,
        error: null,
        request: action.request,
      };
    case ADD_MANAFITH_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
        request: action.request,
      };
    case ADD_MANAFITH_REMOVE:
      return initialState;

    default:
      return state;
  }
};
